import { makeStyles } from '@material-ui/styles'
import { navBarHeight } from 'styling/theme'

export const useStyles = makeStyles(({ typographyPresets, colors }) => ({
    root: {
        backgroundColor: colors.light.lightGray,
        padding: `calc(40px + ${navBarHeight}px) 10% 66px 10%`,
        height: '100%',
        overflow: 'auto',
    },
    title: {
        ...typographyPresets.titleMedium,
    },
    tabsRoot: {
        marginTop: '20px',
        borderBottom: `1px solid ${colors.light.grey}`,
    },
    tabsIndicator: {
        height: '3px',
        backgroundColor: colors.brand.green2,
    },
    tabRoot: {
        color: '#575f66',
        textTransform: 'none',
        fontSize: '16px',
        padding: 0,
        marginRight: '32px',
        minWidth: '50px',
    },
    tabSelected: {
        color: colors.black,
    },
    tabWrapper: {
        alignItems: 'flex-start',
    },
}))
